import axios from "axios";
import { useState } from "react";
import { Link } from "react-router-dom";

export default function AddAdmin() {
    const [data, setData] = useState({ name: "", email: "", password: "" });

    const register = async (e) => {
        e.preventDefault();

        const token = localStorage.getItem("admin-token");

        try {
            await axios.post("https://apnaqwebx-mern.onrender.com/api/auth/register", data, {
                headers: {
                    Authorization: token
                }
            });

            alert("New admin created!");

        } catch (err) {
            alert(err.response?.data?.message);
        }
    };

    return (<>
        <div className="p-6 mt-7 pt-24 max-w-lg mx-auto">

            <div className="flex justify-between items-center mb-6">
                {/* Heading */}
                <h2 className="text-3xl font-bold text-[#895712] text-center ">
                    Create New Admin
                </h2>

                <Link to="/admin/adminlist" ><i className="fa-solid fa-square-caret-left text-3xl text-[#895712]"></i></Link>
            </div>
            <form onSubmit={register} className="space-y-6 bg-white shadow-lg p-8 rounded-xl border border-[#e7d5c2]">

                {/* NAME */}
                <div>
                    <label className="text-[#895712] font-medium">Full Name</label>
                    <div className="flex items-center border border-[#895712] rounded-lg px-3 mt-1">
                        <i className="fa-solid fa-user text-[#895712]"></i>
                        <input
                            type="text"
                            placeholder="Enter full name"
                            value={data.name}
                            onChange={(e) => setData({ ...data, name: e.target.value })}
                            className="w-full px-2 py-2 outline-none"
                            required
                        />
                    </div>
                </div>

                {/* EMAIL */}
                <div>
                    <label className="text-[#895712] font-medium">Email</label>
                    <div className="flex items-center border border-[#895712] rounded-lg px-3 mt-1">
                        <i className="fa-solid fa-envelope text-[#895712]"></i>
                        <input
                            type="email"
                            placeholder="Enter email"
                            value={data.email}
                            onChange={(e) => setData({ ...data, email: e.target.value })}
                            className="w-full px-2 py-2 outline-none"
                            required
                        />
                    </div>
                </div>

                {/* PASSWORD */}
                <div>
                    <label className="text-[#895712] font-medium">Password</label>
                    <div className="flex items-center border border-[#895712] rounded-lg px-3 mt-1">
                        <i className="fa-solid fa-lock text-[#895712]"></i>
                        <input
                            type="password"
                            placeholder="Enter password"
                            value={data.password}
                            onChange={(e) => setData({ ...data, password: e.target.value })}
                            className="w-full px-2 py-2 outline-none"
                            required
                        />
                    </div>
                </div>

                {/* BUTTON */}
                <button
                    type="submit"
                    className="w-full bg-[#895712] hover:bg-red text-white font-semibold py-3 rounded-lg shadow-md transition"
                >
                    Create Admin
                </button>

            </form>
        </div>

    </>
    );
}
